"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withLanguage = exports.QuantityUOM = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var frontend_form_controls_1 = require("@ryerson/frontend.form-controls");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var frontend_notification_1 = require("@ryerson/frontend.notification");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_common_2 = require("@ryerson/frontend.common");

var useDocument = function useDocument() {
  var _react_1$default$useS = react_1.default.useState(null),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      localDocument = _react_1$default$useS2[0],
      setLocalDocument = _react_1$default$useS2[1];

  react_1.default.useEffect(function () {
    setLocalDocument(document);
  }, []);
  return localDocument;
};

var QuantityUOM = function QuantityUOM(_ref) {
  var id = _ref.id,
      itemData = _ref.itemData,
      _ref$isMobile = _ref.isMobile,
      isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile,
      uomValue = _ref.uomValue,
      quantityValue = _ref.quantityValue,
      _ref$quantityInputWid = _ref.quantityInputWidth,
      quantityInputWidth = _ref$quantityInputWid === void 0 ? 66 : _ref$quantityInputWid,
      _ref$uomInputWidth = _ref.uomInputWidth,
      uomInputWidth = _ref$uomInputWidth === void 0 ? 77 : _ref$uomInputWidth,
      _ref$popperWidth = _ref.popperWidth,
      popperWidth = _ref$popperWidth === void 0 ? 250 : _ref$popperWidth,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      size = _ref.size,
      _ref$showLabel = _ref.showLabel,
      showLabel = _ref$showLabel === void 0 ? false : _ref$showLabel,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      disabledQuantity = _ref.disabledQuantity,
      _ref$isSubmitted = _ref.isSubmitted,
      isSubmitted = _ref$isSubmitted === void 0 ? false : _ref$isSubmitted,
      handleChange = _ref.handleChange,
      handleValidationResponse = _ref.handleValidationResponse,
      _ref$inputConstraint = _ref.inputConstraint,
      inputConstraint = _ref$inputConstraint === void 0 ? {
    minimum: 0,
    maximum: 99999
  } : _ref$inputConstraint,
      _ref$debounceTime = _ref.debounceTime,
      debounceTime = _ref$debounceTime === void 0 ? 2000 : _ref$debounceTime,
      _ref$popperDisplayTim = _ref.popperDisplayTime,
      popperDisplayTime = _ref$popperDisplayTim === void 0 ? 2000 : _ref$popperDisplayTim,
      inputDataTestId = _ref.inputDataTestId,
      dropdownDataTestId = _ref.dropdownDataTestId,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? "" : _ref$dataTestId,
      _ref$isFocused = _ref.isFocused,
      isFocused = _ref$isFocused === void 0 ? false : _ref$isFocused,
      stateMessenger = _ref.stateMessenger,
      _ref$quantityUomOptio = _ref.quantityUomOptions,
      quantityUomOptions = _ref$quantityUomOptio === void 0 ? [] : _ref$quantityUomOptio,
      DropDownLabelAddition = _ref.DropDownLabelAddition,
      InputLabelAddition = _ref.InputLabelAddition,
      handleUOMChange = _ref.handleUOMChange,
      onDropdownOpen = _ref.onDropdownOpen,
      _ref$recalculateQuant = _ref.recalculateQuantities,
      recalculateQuantities = _ref$recalculateQuant === void 0 ? true : _ref$recalculateQuant,
      quantityInputRef = _ref.quantityInputRef;

  var _a;

  !size && (isMobile ? size = "sm" : size = "md");

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _ref3 = (0, frontend_application_1.useApplication)(),
      language = _ref3.localization.language;

  var content = exports.withLanguage[language || "en"];

  var _ref4 = theme.colors.primary || {},
      white = _ref4.white,
      lightGray = _ref4.lightGray,
      darkGray = _ref4.darkGray,
      text = _ref4.text;

  var _react_1$default$useS3 = react_1.default.useState(uomValue),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      quantityUom = _react_1$default$useS4[0],
      setQuantityUom = _react_1$default$useS4[1];

  var _react_1$default$useS5 = react_1.default.useState(false),
      _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
      isPopperDisplayed = _react_1$default$useS6[0],
      setIsPopperDisplayed = _react_1$default$useS6[1];

  var _react_1$default$useS7 = react_1.default.useState(false),
      _react_1$default$useS8 = _slicedToArray(_react_1$default$useS7, 2),
      isMounted = _react_1$default$useS8[0],
      setHasMounted = _react_1$default$useS8[1];

  var _react_1$default$useS9 = react_1.default.useState(false),
      _react_1$default$useS10 = _slicedToArray(_react_1$default$useS9, 2),
      displayTrigger = _react_1$default$useS10[0],
      setDisplayTrigger = _react_1$default$useS10[1];

  var _react_1$default$useS11 = react_1.default.useState(false),
      _react_1$default$useS12 = _slicedToArray(_react_1$default$useS11, 2),
      defferChangeTrigger = _react_1$default$useS12[0],
      setDefferChangeTrigger = _react_1$default$useS12[1];

  var numberInputRef = react_1.default.useRef();
  var isError = react_1.default.useRef(false);
  var isRecalculate = react_1.default.useRef(false);
  var userChangedValue = react_1.default.useRef(false);
  var userChangedUOM = react_1.default.useRef(false);
  var isInteractingWithPricingUOM = react_1.default.useRef();
  var isInteractingWithQTYUOM = react_1.default.useRef();
  var doc = useDocument();
  var query = doc && ((_a = doc.querySelector) === null || _a === void 0 ? void 0 : _a.bind(doc));

  var _react_1$default$useS13 = react_1.default.useState(quantityValue),
      _react_1$default$useS14 = _slicedToArray(_react_1$default$useS13, 2),
      displayQuantity = _react_1$default$useS14[0],
      setDisplayQuantity = _react_1$default$useS14[1]; // create state array to hold the messages


  var _react_1$default$useS15 = react_1.default.useState([]),
      _react_1$default$useS16 = _slicedToArray(_react_1$default$useS15, 2),
      message = _react_1$default$useS16[0],
      setMessage = _react_1$default$useS16[1]; // these items with ids will disrupt the debounce timeout then set deferred value


  var Ids = ["quantity-uom-dropdown-".concat(id)];
  var valueToDebounce = "".concat(typeof displayQuantity !== "undefined" ? displayQuantity : "");
  var debouncedQuantity = (0, frontend_common_1.useDebouncerPlus)(id, valueToDebounce, debounceTime, Ids, stateMessenger, !isRecalculate.current); // Start Local Debounce/Interval when Pub Messages from Pricing UOM component indicated user has interacted with PricingUOM

  var setSelectInteractionResult = function setSelectInteractionResult(eventType) {
    var selectLeaveEvents = ["blur", "change", "mouseout"];
    var selectEnterEvents = ["mousedown", "click", "focus"];
    var previousState = isInteractingWithPricingUOM.current;
    selectEnterEvents.includes(eventType) && (isInteractingWithPricingUOM.current = true);
    selectLeaveEvents.includes(eventType) && (isInteractingWithPricingUOM.current = false);

    if (!isInteractingWithPricingUOM.current && !!previousState && !defferChangeTrigger) {
      setDefferChangeTrigger(true);
    }
  };

  react_1.default.useEffect(function () {
    setQuantityUom(uomValue);
  }, [uomValue]);
  react_1.default.useEffect(function () {
    var _a;

    if (isMounted && isFocused) {
      (_a = numberInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }, [isFocused]);
  /***
   *  @desc  UseEffect [quantityValue]
   *  This handles incoming (not typed in) quantityValue prop that has value of undefined
   ***/

  react_1.default.useEffect(function () {
    if (isMounted && quantityValue === undefined && displayQuantity !== undefined) {
      setIsPopperDisplayed(false);
      handleQuantityOnChange("");
    } else if (quantityValue !== displayQuantity) {
      setDisplayQuantity(quantityValue);
    }
  }, [quantityValue]);
  /***
   *  @desc UseEffect [displayQuantity]
   *  handle displayQuantity has been changed, call validation Response callback
   ***/

  react_1.default.useEffect(function () {
    if (isMounted && !isRecalculate.current) {
      var hasError = inputIsInError(displayQuantity);
      handleValidationResponse && handleValidationResponse(hasError, itemData.id);
    }
  }, [displayQuantity]);
  /***
   *  @desc  handleQuantityOnChange()
   *  Change Event Handler to Set displayQuantity state to numeric value or undefined
   *  user has typed in a value.
   ***/

  var handleQuantityOnChange = function handleQuantityOnChange(value) {
    var inputHasLength = "".concat(value).length;
    var newValue = inputHasLength ? Number(value) : undefined;
    var minimum = inputConstraint.minimum,
        maximum = inputConstraint.maximum;
    newValue = typeof newValue === "number" ? Math.min(Math.max(newValue, minimum), maximum) : newValue;

    if (newValue !== displayQuantity) {
      isRecalculate.current = false;
      setDisplayQuantity(newValue);
    }
  };

  var publishMessage = function publishMessage(messageString, data, topic) {
    /* note the use of setTimeout is required for publishing messages*/
    setTimeout(function () {
      return stateMessenger === null || stateMessenger === void 0 ? void 0 : stateMessenger.publish(messageString, data, topic);
    }, 10);
  };
  /**
   * Messages from external components via pub sub
   */


  react_1.default.useEffect(function () {
    var _message = _slicedToArray(message, 3),
        messageString = _message[0],
        value = _message[1],
        dropDownId = _message[2]; // determine is (external) select dropdown are being used


    messageString === "to-debounce" && "".concat(dropDownId) === "".concat(id) && setSelectInteractionResult(value);
  }, [message]);
  /***
   *  @desc Hook: useCheckValueInterval
   *   Deals with setting up a debounce/interval when user interacts with UOM dropdown or Pricing UOM  (has not typed in quantity value)
   *   this does a check when timer runs out see if if needs to do the recalculation and ,ale onchange callback
   *   which (normally handled by the input debounce), however if user then interacts with input or other dropdown
   *   this timeout action is cancelled, since the uses the standard debounce functionality
   ***/

  (0, frontend_common_1.useCheckValueInterval)(function () {
    // tell pricing uom were done debouncing
    publishMessage("is-debouncing", false, id); // has user has not started changing quantity  then trigger recalc & onchange callback

    if (!hasInputChanged() && !isInteractingWithPricingUOM.current) {
      userChangedValue.current = true;
      recalculateQuantityAndChange();
    } // kill this interval/debounce session


    setDefferChangeTrigger(false);
  }, function (count) {
    if (isInteractingWithQTYUOM.current || isInteractingWithPricingUOM.current) {
      publishMessage("is-debouncing", false, id);
      setDefferChangeTrigger(false);
    }
  }, defferChangeTrigger, debounceTime / 3, 3); // The Interval Debouncing has started, so let external components know

  react_1.default.useEffect(function () {
    // this tells pricing uom dropdown we are now debouncing
    isMounted && defferChangeTrigger && publishMessage("is-debouncing", true, id);
  }, [defferChangeTrigger]);
  /***
   *  @desc UseEffect[hasInputChanged]
   * compare state value and  DOM input element value
   ***/

  var hasInputChanged = function hasInputChanged() {
    var El = query && query("#quantity-uom-input-".concat(id));
    return "".concat(displayQuantity) !== "".concat((El === null || El === void 0 ? void 0 : El.value) || "");
  };
  /***
   *  @desc UseEffect[isSubmitted]
   * Deal with isSubmitted Prop updated, validate input
   ***/


  react_1.default.useEffect(function () {
    if (isMounted && isSubmitted) {
      validateInput(displayQuantity);
    }
  }, [isSubmitted]);
  /***
   *  @desc  @UseEffect [debounce]
   *  delay of incoming value, check to see if we need to recalculate input and redisplay it with new state
   ***/

  react_1.default.useEffect(function () {
    var legitValue = typeof displayQuantity !== "undefined" && !isRecalculate.current && !!debouncedQuantity && Number(debouncedQuantity) > 0 && userChangedValue.current; // Note: user ONLY changed UOM dropped down but did'nt change qty value
    // start debounce/interval

    var userOnlyChangedQtyUOM = !userChangedValue.current && userChangedUOM.current && !!displayQuantity;

    if (userOnlyChangedQtyUOM) {
      setDefferChangeTrigger(true);
    }

    if (isMounted && legitValue && !defferChangeTrigger) {
      recalculateQuantityAndChange();
    } else {
      // Reset Flags
      !!debouncedQuantity && (isRecalculate.current = false);
    }
  }, [debouncedQuantity, quantityUom]);
  /***
   *  @desc recalculateQuantityAndChange -   call recalculation function,show popper, the onChange Callback for this component
   ***/

  var recalculateQuantityAndChange = function recalculateQuantityAndChange() {
    var quantityToDisplay = recalculateQuantities ? recalculateQuantity(displayQuantity) : displayQuantity; //show the popper and show new calculated number

    if (quantityToDisplay !== Number(displayQuantity)) {
      isRecalculate.current && setIsPopperDisplayed(true);
      setDisplayQuantity(quantityToDisplay);
    }

    !!userChangedValue.current && handleChange && handleChange(quantityToDisplay, quantityUom); // Reset Flags (important)

    userChangedValue.current = false;
    userChangedUOM.current = false;
  };
  /***
   *  @desc recalculateQuantity - rounds up values to appropriated amount for particular uom value
   ***/


  var recalculateQuantity = function recalculateQuantity(quantity) {
    var isNonZero = displayQuantity !== 0;
    isRecalculate.current = isNonZero;
    var updatedQuantity = undefined;

    if (isRecalculate.current) {
      /**
       * Check that the user’s quantity corresponds to a full piece.
       * If it does, then the `updatedQuantity` will yield the next quantity for an extra piece (user inputs 50lbs, updatedQty will be 100lbs).
       * That’s not what we want: if the user inputs the quantity for a full piece, then don’t change it
       * (user inputs 50lbs, it’s a full piece, leave it).
       */
      var provisionalQty = (0, frontend_common_1.updatedQuantityBasedOnQuantityUom)(itemData, quantityUom, quantity - 1);
      updatedQuantity = (0, frontend_common_1.updatedQuantityBasedOnQuantityUom)(itemData, quantityUom, quantity);

      if (provisionalQty === quantity) {
        updatedQuantity = provisionalQty;
      }
    }

    return !!updatedQuantity ? updatedQuantity : quantity;
  };
  /***
   *  @desc  UseEffect all validation response to set if table is valid
   ***/


  react_1.default.useEffect(function () {
    window && (window === null || window === void 0 ? void 0 : window.setTimeout(function () {
      numberInputRef.current = document === null || document === void 0 ? void 0 : document.querySelector("[data-testid=".concat(inputDataTestId !== null && inputDataTestId !== void 0 ? inputDataTestId : "number-input-" + id, "]"));
      var hasError = inputIsInError(displayQuantity);
      handleValidationResponse && handleValidationResponse(hasError, itemData.id);
    }, 10));
  }, [isMounted]);
  react_1.default.useEffect(function () {
    stateMessenger === null || stateMessenger === void 0 ? void 0 : stateMessenger.subscribe(function (msg, value, topic) {
      return setMessage([msg, value, topic]);
    });
    setHasMounted(true);
  }, []);
  /***
   *  @desc getPopperColor()
   *  Utility Function to set color for popper based on ControlType( primary | secondary | tertiary)
   ***/

  var getPopperColor = function getPopperColor(whichElType) {
    switch (type) {
      case "tertiary":
        return {
          text: text,
          background: white,
          border: lightGray
        }[whichElType];

      case "primary":
      case "secondary":
      default:
        return {
          text: white,
          background: darkGray,
          border: lightGray
        }[whichElType];
    }
  };

  var PopperContent = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\twidth: ", "px;\n\t"])), popperWidth);

  var inputIsInError = function inputIsInError(val) {
    var isUndefined = !!(typeof val === "undefined");
    var isZero = !!(Number(val) === 0);
    return isZero || isUndefined;
  };
  /***
   *  @desc validateInput()
   *  Validator call back for input component
   ***/


  var validateInput = function validateInput(val) {
    isError.current = inputIsInError(val);
    isError.current && isSubmitted && setDisplayTrigger(!displayTrigger);
    return isError.current ? frontend_common_2.CONSTANTS[language].REQUIRED_FIELD : "";
  };

  return (0, jsx_runtime_1.jsx)("div", {
    className: "qty-uom-component-root",
    "data-testid": dataTestId,
    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      className: "qty-uom-component-column",
      direction: "column",
      children: [(0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
        alignItems: "flex-start",
        children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
          "align-items": "flex-start",
          className: "qty-uom-component-row",
          css: {
            width: "".concat(quantityInputWidth).concat(quantityInputWidth.toString().includes("%") ? "" : "px"),
            marginRight: 10,
            minWidth: isMobile ? 120 : "unset"
          },
          children: (0, jsx_runtime_1.jsx)(frontend_form_controls_1.NumberInput, {
            labelAddition: InputLabelAddition,
            id: "quantity-uom-input-".concat(id),
            className: "quantity-uom-input-".concat(id),
            inputRef: quantityInputRef,
            value: displayQuantity || "",
            disabled: disabledQuantity !== undefined ? disabledQuantity : disabled,
            validation: validateInput,
            isValid: !isError.current,
            submitted: false,
            required: true,
            label: showLabel ? content.quantity : undefined,
            type: type,
            dataTestId: inputDataTestId !== null && inputDataTestId !== void 0 ? inputDataTestId : "number-input-".concat(id),
            size: size,
            onBlur: function onBlur(val) {
              return isSubmitted && validateInput(val);
            },
            onKeyDown: function onKeyDown(e) {
              userChangedValue.current = true;
              return e.key.match(/\D^Backspace/) && e.preventDefault();
            },
            onChange: function onChange(e) {
              var value = e.target.value;
              isSubmitted && validateInput(value);
              setIsPopperDisplayed(false);
              handleQuantityOnChange(value);
              setDefferChangeTrigger(false);
            },
            language: language
          })
        }), (0, jsx_runtime_1.jsx)("div", {
          css: {
            width: "".concat(uomInputWidth).concat(uomInputWidth.toString().includes("%") ? "" : "px")
          },
          children: (0, jsx_runtime_1.jsx)(frontend_form_controls_1.Dropdown, {
            onDropdownOpen: onDropdownOpen,
            labelAddition: DropDownLabelAddition,
            disabled: disabled || quantityUomOptions.length <= 1,
            label: showLabel ? content.uom : undefined,
            dataTestId: dropdownDataTestId,
            id: "quantity-uom-dropdown-".concat(id),
            type: type,
            value: quantityUom,
            options: quantityUomOptions,
            onChange: function onChange(value) {
              isInteractingWithQTYUOM.current = false;
              userChangedUOM.current = true;
              setQuantityUom(value);
              handleUOMChange && handleUOMChange(value);
            },
            size: size,
            language: language
          })
        })]
      }), numberInputRef.current && (0, jsx_runtime_1.jsx)(frontend_common_1.Popper, {
        id: id,
        type: type,
        targetEl: numberInputRef.current,
        backColor: getPopperColor("background"),
        borderColor: getPopperColor("border"),
        offsetY: 4,
        displayTime: popperDisplayTime,
        placement: "bottom",
        isDisplaying: isPopperDisplayed,
        handlePopperTimedOut: function handlePopperTimedOut() {
          return setIsPopperDisplayed(false);
        },
        onClick: function onClick() {
          setIsPopperDisplayed(false);
        },
        children: (0, jsx_runtime_1.jsx)(PopperContent, {
          children: (0, jsx_runtime_1.jsx)(frontend_notification_1.Alert, {
            size: "sm",
            severity: "info",
            children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              color: getPopperColor("text"),
              children: content.quantityRecalculatedNotify
            })
          })
        })
      })]
    })
  });
};

exports.QuantityUOM = QuantityUOM;
exports.withLanguage = {
  en: {
    quantity: "Quantity",
    uom: "UOM",
    quantityRecalculatedNotify: "Values have been updated"
  },
  es: {
    quantity: "Cantidad",
    uom: "UOM",
    quantityRecalculatedNotify: "Los números han sido actualizados"
  },
  fr: {
    quantity: "Quantité",
    uom: "UOM",
    quantityRecalculatedNotify: "Les chiffres ont été mis à jour"
  }
};